import React, { useEffect, useMemo, useRef } from 'react';
import { Container, Sprite } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { gameDrawer } from '../../../../services/gameDrawer';
import { gameResourcesService } from '../../../../services/gameResourcesService';

import { isMobile } from '../../../../core/helpers/isMobile';

import TextOrderingByWidth from '../../textOrderingByWidth';
import { isoStandard } from '../../../../core/helpers/isoStandard';
import { applicationStore } from '../../../../store/applicationStore';

const WinAmountComponent = observer(
  ({
    isVisible,
    amountValue,
    currencySymbol,
    backGroundTexture,
    canvasTranslationKeys,
    hasBackGround = true,
    x = 0,
    y = 0,
  }) => {
    const winAmountTextureRef = useRef();
    const { isShowLicenseMode, isDemo } = applicationStore;

    const texts = useMemo(() => {
      return [
        {
          id: 0,
          text: `${canvasTranslationKeys.WIN}:`,
          style: { fill: '#FFC33E', _fontWeight: 700, _fontSize: isMobile() ? 20 : 20 },
          ref: null,
        },
        {
          id: 1,
          text: isoStandard(amountValue, true),
          style: { fill: '#FFFFFF', _fontWeight: 700, _fontSize: isMobile() ? 24 : 26 },
          ref: winAmountTextureRef,
        },
        {
          id: 2,
          text: currencySymbol,
          style: { fill: '#FFFFFF', _fontWeight: 700, _fontSize: isMobile() ? 20 : 26 },
          ref: null,
        },
      ];
    }, [amountValue, canvasTranslationKeys.WIN, currencySymbol]);

    const updateTextByLicense = useMemo(() => {
      return isShowLicenseMode && !isDemo ? [texts[0], texts[2], texts[1]] : texts;
    }, [isShowLicenseMode, isDemo, texts]);

    useEffect(() => {
      if (winAmountTextureRef.current) {
        gameResourcesService.setWinAmountTexture(winAmountTextureRef.current);
        gameDrawer.animateWinAmount({ value: amountValue });
      }
    }, [winAmountTextureRef, amountValue]);

    return (
      <Container name='WinAmountContainer' visible={isVisible} x={x} y={y}>
        {hasBackGround && (
          <Sprite anchor={0.5} scale={isMobile() ? 0.77 : 0.5} texture={backGroundTexture} />
        )}
        <TextOrderingByWidth texts={updateTextByLicense} />
      </Container>
    );
  }
);

export default WinAmountComponent;
